const reducers = (state = {}, action) => {
  switch (action.type) {
    case 'LOG_IN':
      return {
        ...state,
        isAuthenticated: true,
        profile: action.profile
      }
    case 'LOG_OUT':
      return {
        ...state,
        isAuthenticated: false,
        profile: null
      }
    case 'SAVE_PERMISSIONS':
      return {
        ...state,
        permissions: action.permissions
      }
    default:
      return state
  }
}

export default reducers
